import { useQueryParams } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { AddMiniIcon } from '@calendly/ui/components/icons'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { useBillingFeaturesAccess } from 'features/routing/features_access'
import { newFormUrl } from 'features/routing/url'
import { isAdminOrOwnerOrGroupAdminSelector } from 'selectors/current_user'

import { useFetchFormsQuery } from '../api'

export const CreateButton = ({ allowCreateWhenEmpty = false, ...props }) => {
  const params = useQueryParams()
  const { data, isFetching } = useFetchFormsQuery(params)
  const { isRoutingFormsAvailable } = useBillingFeaturesAccess()
  const canCreateForm = useSelector(isAdminOrOwnerOrGroupAdminSelector)

  if (isFetching) return null

  const { collection: forms = [] } = data
  const hasForms = forms.length > 0

  if (!isRoutingFormsAvailable) return null
  if (!hasForms && !allowCreateWhenEmpty) return null
  if (!canCreateForm) return null

  return (
    <Button {...props} as={Link} to={newFormUrl('type')}>
      <AddMiniIcon size="large" />
      {I18n.t('publisher.routing.forms.index.new_form_button')}
    </Button>
  )
}
